import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-enrollments',
  templateUrl: './service-enrollments.component.html',
  styleUrls: ['./service-enrollments.component.css']
})
export class ServiceEnrollmentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
